import { render, staticRenderFns } from "./signingLegwork.vue?vue&type=template&id=ebc4624a&scoped=true&"
import script from "./signingLegwork.vue?vue&type=script&lang=js&"
export * from "./signingLegwork.vue?vue&type=script&lang=js&"
import style0 from "./signingLegwork.vue?vue&type=style&index=0&id=ebc4624a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebc4624a",
  null
  
)

export default component.exports